var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { AfyModal } from "@affinitysystemsgroup/assurehub-ui";
import { FormBenefitAFY } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { BENEFIT_FORM_TITLE } from "../../../constants/planCreation.constants";
var MODAL_PROPS = {
    centered: true,
    size: 700,
};
export var ModalBenefit = function (props) { return (_jsx(AfyModal, __assign({}, MODAL_PROPS, { opened: props.openModal, onClose: props.onClose }, { children: _jsx(FormBenefitAFY, { title: BENEFIT_FORM_TITLE, dataFormBenefits: props.dataFormBenefits, onClickCancel: props.onClose, onNext: props.onSave }) }))); };
